ui-cms-partner-logos-footer {
  display: block;

  p {
    font-size: 1rem;
    margin: 0;
    margin-top: 16px;
  }

  .logos {
    overflow: hidden;

    > ui-link {
      float: left;
      width: auto;
      margin: 0 20px 20px 0;

      &:last-child {
        margin-right: 0;
      }
    }

    img {
      max-height: 36px;
      width: auto;
      height: 36px;

      @include breakpoint($small) {
        max-height: 20px;
      }
    }
  }
}
